import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowRight } from 'lucide-react'

import { Container } from '@/components/common/container'
import { Seo } from '@/components/common/seo'
import { Button } from '@/components/ui/button'
import { FadeIn } from '@/components/motion/fade-in'
import { ruleSections } from '@/features/rules/rules-content'

export const Route = createFileRoute('/rules')({
  component: RulesRoute,
})

function RulesRoute() {
  return (
    <>
      <Seo
        title="Checkers Rules"
        description="A concise reference for standard checkers: how pieces move, mandatory captures, chained jumps, kings, and how a game is won."
        path="/rules"
      />

      <Container className="flex flex-col gap-10 py-10 sm:gap-12 sm:py-14">
        <FadeIn className="flex flex-col gap-3">
          <h1 className="text-display-md sm:text-display-lg text-foreground">Checkers Rules</h1>
          <p className="text-muted-foreground max-w-xl text-lg">
            Standard rules, exactly as enforced on the board.
          </p>
        </FadeIn>

        <ol className="flex flex-col gap-8">
          {ruleSections.map((section, index) => (
            <FadeIn key={section.title} delay={index * 0.05} as="li" className="flex gap-4">
              <span className="text-brand text-sm font-semibold">
                {String(index + 1).padStart(2, '0')}
              </span>
              <div className="flex flex-col gap-1.5">
                <h2 className="text-foreground text-lg font-semibold">{section.title}</h2>
                <p className="text-muted-foreground max-w-2xl leading-relaxed">{section.body}</p>
              </div>
            </FadeIn>
          ))}
        </ol>

        <div>
          <Button asChild size="lg">
            <Link to={'/play' as never}>
              Play now
              <ArrowRight className="size-4" />
            </Link>
          </Button>
        </div>
      </Container>
    </>
  )
}
